<div class="wrapper">
<header class="main-header navbar navbar-expand navbar-black navbar-dark">
  <!-- Left navbar links -->
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
    </li>
  </ul>
  <div class="oliosLogo noselect">
    <img src="assets/images/olios_logo.png" alt="Olios Logo" style="opacity: .8; width: 20%;">
  </div>
  <ul class="navbar-nav ml-auto">
      <!-- Notifications Dropdown Menu -->
      <div class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" id="dropdownMenuLink" role="button">
          <span class="mr-2 noselect">{{userName.displayName}}</span><i class="fas fa-cog"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="dropdownMenuLink">
          <a routerLink="user/user-profile" href="#" class="dropdown-item">
            <i class="fas fa-user-alt mr-2"></i> Profile
          </a>
          <div class="dropdown-divider"></div>
          <a routerLink="user/change-password" href="#" class="dropdown-item">
            <i class="fas fa-fingerprint mr-2"></i> Change Password
          </a>
          <div class="dropdown-divider"></div>
          <a (click)="signout()" href="#" class="dropdown-item">
            <i class="fas fa-sign-out-alt mr-2"></i> Logout
          </a>
        </div>
      </div>
  </ul>
</header>

<aside class="main-sidebar sidebar-dark-primary elevation-4">
  <!-- Brand Logo -->
  <a href="/" class="brand-link">
    <img *ngIf="isImage; else defaultlogo" [src]="getLogo()" alt="Logo" class="brand-image" style="opacity: .8">
    <ng-template #defaultlogo>
      <img src="assets/images/logo.png" alt="Olios Logo" class="brand-image" style="opacity: .8">
    </ng-template>
    <span class="brand-text font-weight-light noselect">{{orgName}}</span>
  </a>

  <!-- Sidebar -->
  <div class="sidebar">
    <input type="text" [(ngModel)]="searchQuery" placeholder="Search In Menu" class="form-control mb-2 mt-2"/>
    <!-- Sidebar Menu -->
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <li class="nav-item mt-2" *ngFor="let menu of filteredMenuList()">
            <a id="navMenuLink{{menu.id}}" routerLink="{{ menu.href }}" class="nav-link" routerLinkActive="active">
              <i class="{{menu.cssClass}} mr-2"></i>
              <p>
                {{ menu.name }}
              </p>
            </a>
          </li>

      </ul>
    </nav>
    <!-- /.sidebar-menu -->
  </div>
  <!-- /.sidebar -->
</aside>
</div>
